import { mapState, mapGetters } from 'vuex'
import { loadLiveList, loadActivityType, thumbUp, wantLive } from '@/api/live'
import { eventMixin } from '@/mixins/event.js'

const liveMixin = {
    data() {
        return {
            hotLiveList: [],
            recommentList: [],
            activeArr: [], //侧边导航栏
        }
    },
    mixins: [eventMixin],
    computed: {
        ...mapGetters(['subjectType']),
        ...mapState({
            liveType: (state) => state.live.liveType,
            liveState: (state) => state.live.liveState,
            liveParty: (state) => state.live.liveParty,
            activityType: (state) => state.live.activityType,
            moreType: (state) => state.live.moreType,
            orderDesc: (state) => state.live.orderDesc,
            totalPage: (state) => state.live.totalPage,
            pageNum:(state) => state.live.pageNum,
            liveLists:(state) => state.live.liveLists,
            totalPage1: (state) => state.live.totalPage1,
            pageNum1:(state) => state.live.pageNum1,
            liveLists1:(state) => state.live.liveLists1,
            pageRows:(state) => state.live.pageRows,
            liveOptParty: (state) => state.live.liveOptParty,
            
        }),
        liveList() {
            return this.liveLists
        },
        liveList1() {
            return this.liveLists1
        }
    },

    methods: {
        callback(res) {
            if (res.type == 'exhibitsDetails') {
                //展品详情
                this.pageDetail(res.data, 'product')
            } else if (res.type == 'details') {
                //展商详情
                this.pageDetail(res.data, 'actor')
            } else if (res.type == 'live') {
                //直播详情
                this.pageDetail(res.data, 'live')
            } else if (res.type == "like") {
                // 点赞
                thumbUp({
                    liveId: res.data.id
                }).then(r => {
                    if (r.data.code == 1000) {
                        let arr = [...this.liveLists];
                        for (let i = 0; i < arr.length; i++) {
                            let o = arr[i];
                            if (o.id == res.data.id) {
                                res.data.liveLikeCount = res.data.liveLikeCount * 1 + 1;
                                arr[i] = res.data;
                                this.commitState({
                                    'key': 'liveLists',
                                    'val': arr
                                })
                                break
                            }
                        }
                    }
                })
            } else if (res.type == 'miss') {
                // 想看
                if (res.data.wantLive == 0) { //未点击过
                    wantLive({
                        liveId: res.data.id
                    }).then(r => {
                        if (r.data.code == 1000) {
                            let arr = [...this.liveLists];
                            for (let i = 0; i < arr.length; i++) {
                                let o = arr[i];
                                if (o.id == res.data.id) {
                                    res.data.liveWantCount = res.data.liveWantCount * 1 + 1;
                                    arr[i] = res.data;
                                    this.commitState({
                                        'key': 'liveLists',
                                        'val': arr
                                    })
                                    res.data.wantLive = 1;
                                    break
                                }
                            }
                        }
                    })
                } else {
                    console.log('请不要重复点击想看...')
                }
            }
        },
        commitState(param) {
            let _this = this;
            param.key && _this.$store.commit('liveChange', {
                key: param.key,
                val: param.val
            });
        },
        commitAndLoadData(val,param = {}) {
            param.key && this.commitState(param);
            delete param.key
            delete param.val
            this.loadLiveListData(val,{
                pageNum: 1
            })
        },
        changeLiveState(param) { //点击 直播-待直播
            this.commitState({
                key: 'liveType',
                val: 1
            })
            this.commitAndLoadData(1,param);
            this.commitAndLoadData(2,param);
        },
        changeLiveType(param) { //点击回放
            window.PC.$RangersEventLive('view', {type: param.val})
            this.commitState({
                key: 'liveState',
                val: 0
            })
            this.commitAndLoadData(1,param);
            this.commitAndLoadData(2,param);
        },
        //搜索-按钮
        searchLiveName() {
            window.PC.$RangersEventLive('search', {type: this.liveType})
            this.commitAndLoadData(1)
            this.commitAndLoadData(2)
        },
        loadLiveListData(liveParty, param = {}) {
            /**
             * 0 => 全部
             * 1 => 同期活动
             * 2 => 展商直播
             */
            if (this.lParty && liveParty !== this.lParty) return
            if (this.subjectType == 'ACTOR' && liveParty !== 1) return
            let _this = this;
            param.liveType = _this.liveType * 1;
            param.liveParty = liveParty;
            param.activityType = _this.activityType;
            param.orderDesc = _this.orderDesc;
            param.keyWord=_this.keyWord;
            param.liveEndTime=_this.datetimerange?_this.datetimerange[1] : '';
            param.liveStartTime=_this.datetimerange?_this.datetimerange[0] : '';
            param.pageRows=12;
            _this.loadingPage = true
            loadLiveList(param).then(res => {
                if (res.data.code == 1000) {
                    if(liveParty == 2) {
                        _this.commitState({
                            'key': 'liveLists',
                            'val': res.data.data.records
                        })
                        _this.commitState({
                            'key': 'totalPage',
                            'val': res.data.data.totalPage
                        })
                        _this.commitState({
                            'key': 'pageNum',
                            'val': res.data.data.pageNum
                        })
                    } else if (liveParty == 1) {
                        _this.commitState({
                            'key': 'liveLists1',
                            'val': res.data.data.records
                        })
                        _this.commitState({
                            'key': 'totalPage1',
                            'val': res.data.data.totalPage
                        })
                        _this.commitState({
                            'key': 'pageNum1',
                            'val': res.data.data.pageNum
                        })
                    }
                    
                    _this.commitState({
                        'key': 'pageRows',
                        'val': param.pageRows
                    })
                }
            }).finally(() => {
                _this.loadingPage = false
            })
        },
        getActivityType() {
            let _this = this;
            loadActivityType({
                useType: 2
            }).then(res => {
                _this.activeArr = res.data.data;
            })
        },
        // 直播类型change
        selectChange(val) {
            window.PC.$RangersEventLive('search', {type: this.liveType})
            let _this = this;
            _this.commitState({
                key: 'liveParty',
                val: val
            });
            _this.commitState({
                key: 'liveOptParty',
                val: val
            });
            if(val == 1) {
                _this.loadLiveListData(val,{
                    pageNum: 1
                })
                _this.commitState({
                    'key': 'liveLists',
                    'val': []
                })
            } else if (val == 2) {
                _this.loadLiveListData(val,{
                    pageNum: 1
                })
                _this.commitState({
                    'key': 'liveLists1',
                    'val': []
                })
            } else if (val == 0) {
                _this.loadLiveListData(1,{
                    pageNum: 1
                })
                _this.loadLiveListData(2,{
                    pageNum: 1
                })
            }
        },
        // 排序
        selectChange2(val) {
            window.PC.$RangersEventLive('search', {type: this.liveType})
            let _this = this;
            _this.commitState({
                key: 'orderDesc',
                val: val
            });
            _this.loadLiveListData(1,{
                pageNum: 1
            })
            _this.loadLiveListData(2,{
                pageNum: 1
            })
        },
        // 展商直播翻页
        changePage(v) {
            this.loadLiveListData(2,{
                pageNum: v
            })
        },
        // 主办直播翻页
        changePage1(v) {
            this.loadLiveListData(1,{
                pageNum: v
            })
        }
    }
}
export default liveMixin